export const OPINIONTYPE = {
  FUNCTION_SUGGESTION: 'FUNCTION_SUGGESTION',
  EXPERIENCE_SUGGESTIONS: 'EXPERIENCE_SUGGESTIONS',
  CONTENT_SUGGESTIONS: 'CONTENT_SUGGESTIONS',
  BUG_FEEDBACK: 'BUG_FEEDBACK',
  OTHER_ISSUES: 'OTHER_ISSUES'
};
export const OPINIONTYPE_ZH = {
  FUNCTION_SUGGESTION: '功能建议',
  EXPERIENCE_SUGGESTIONS: '体验建议',
  CONTENT_SUGGESTIONS: '内容建议',
  BUG_FEEDBACK: 'BUG反馈',
  OTHER_ISSUES: '其他问题'
};
